import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Badge, Flex, Text, ThemeUIStyleObject, useColorMode } from 'theme-ui';
import { Paddingset } from '../Button/PaddingSet';
import { HeaderBtn } from '../Button/TabelHeadBtn';
import Export from "../assets/images/Icon/Export.svg";
import { SummeryTime } from './SummeryTime';
import { DropDownURL } from '../Button/DropDownURL';
import ClearTableFilter from '../Button/ClearTableFilter';
import { TaskDropDownFilter } from '../Button/TaskDropDownFilter';
import { useSelector } from 'react-redux';
import { RootState } from '../../../@types';
import UserClock from "../assets/images/user-clock.svg";
import UserRed from "../assets/images/user-clock-red.svg";
interface TabelHeadingprops {
    Title?: string | undefined;
    BtnTxt?: string | undefined;
    Count?: string | number;
    IsBtnShow?: boolean;
    IsExportButtonShow?: boolean;
    IsCreateButtonShow?: boolean;
    sx?: ThemeUIStyleObject;
    onClick?: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined;
    src?: string;
    addText?: string;
    handleClick?: any;
    summeryTime?: boolean;
    limit?: any;
    columns?: any;
    currentPage?: any;
    url?: string;
    ml?: string;
    onExportClick?: () => void;
}

export const TabelHeadingTxt: React.FC<TabelHeadingprops> = ({
    Title = '',
    Count = '',
    BtnTxt,
    IsBtnShow = false,
    IsExportButtonShow = true,
    IsCreateButtonShow = false,
    sx,
    onClick,
    addText,
    src,
    handleClick,
    summeryTime,

    limit,
    columns,
    ml,
    url,
    onExportClick
}) => {
    // const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const navigate = useNavigate();
    const { pathname } = useLocation()
    const isStageView = pathname === "/stage-view"
    const isStageViewTwo = pathname === "/stage-view-two"
    const isTaskView = pathname === "/task-view"
    const isYourTeamView = pathname === "/your-team";

    const allowedRolesForCreateTeam = ["Super Admin", "Project Manager"];
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const togglePopover = () => {
        setIsPopoverOpen(!isPopoverOpen);
    };
    const [isHoursPopover, setIsHoursPopover] = useState(false);
    const toggleHoursPopover = () => {
        setIsHoursPopover(!isHoursPopover);
    };
    const { auther } = useSelector((state: RootState) => state.auth);
    const { timeSummery } = useSelector((state: any) => state.project);

    const hasRole = auther?.Role?.some(r => allowedRolesForCreateTeam.includes(r.RoleName));
    const isOverloaded = (timeSummery?.allocatedHoursExcess?.overloadedManagers?.length > 0 || timeSummery?.allocatedHoursExcess?.overloadedWorkers?.length > 0);
    const overloadedManagers = timeSummery?.allocatedHoursExcess?.overloadedManagers || [];
    const overloadedWorkers = timeSummery?.allocatedHoursExcess?.overloadedWorkers || [];

    const uniqueManagers = overloadedManagers?.filter((manager: any, index: number, self: any) =>
        index === self.findIndex((m: any) => m?._id === manager?._id)
    );

    const uniqueWorkers = overloadedWorkers?.filter((worker: any, index: number, self: any) =>
        index === self.findIndex((w: any) => w?._id === worker?._id)
    );
    // const handleClickOutside = (event: any) => {
    //     if (!event.target.closest('.popover-content')) {

    //         if (!event.target.closest('.toggle-btn')) {
    //             setIsPopoverOpen(false);
    //         }
    //     }
    // };

    // useEffect(() => {
    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, []);

    // let [searchParams, setSearchParams] = useSearchParams();
    // const addQueryStr = (str: string) => {
    // setSearchParams(str)
    // }

    let urlArray = [{ name: "Default", url: "" }, { name: "Custom Order 1", url: `?currentPage=1&stat=${encodeURIComponent('CustomOrder1')}&sortField = ${encodeURIComponent('dueDate,order1')}&istrue = ${encodeURIComponent('true')}&sortOrder = ${encodeURIComponent('asc,asc')}` }, { name: "Custom Order 2", url: "currentPage=1&stat=CustomOrder2&sortField=dueDate,order2&istrue=true&sortOrder=asc,asc&" }, { name: "Delivered", url: "?currentPage=1&status=Delivered" }, { name: "Ready To Deliver", url: "?currentPage=1&status=Ready To Deliver" }, { name: "Draft", url: "?currentPage=1&status=Draft" }]

    if (pathname === '/task-view') {
        urlArray = urlArray.filter(item => !item.name.startsWith("Custom Order"));
    }
    const customDropdownProps = { isPopoverOpen, togglePopover, setIsPopoverOpen, urlArray }
    const [colorMode] = useColorMode();
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    const backgroundColor = colorMode === 'light' ? "white" : "#20283c"
    const popoverRef = useRef<HTMLDivElement | null>(null);
    const iconRef = useRef<HTMLImageElement | null>(null);
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            // Close popover if clicked outside the popover or the icon
            if (popoverRef.current && !popoverRef.current.contains(event.target as Node) &&
                iconRef.current && !iconRef.current.contains(event.target as Node)) {
                setIsHoursPopover(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (
        // <Flex sx={{ justifyContent: 'space-between' }}>
        <div className='container-fluid'>
            <div className='row'>
                <div className=' d-flex' style={{ justifyContent: 'space-between' }}>
                    {/* <div className=''> */}
                    <Text as={"li"} variant='Poppins36Normal35lh' sx={{ textAlign: "start", color: titleHeader }}>
                        {Title}
                        <Badge as={"span"} className="badge" variant='DropDownbedge' sx={{ color: titleHeader }}>{Count}</Badge>
                        {/*<FaChevronDown onClick={togglePopover} style={{ marginLeft: '60px', width: '19px' }} />
                        {isPopoverOpen && (
                            <div className="popover-content" style={{ position: 'fixed', zIndex: 99999999, }}>
                                <Text as={"p"}>Mechanical</Text>
                                <Text as={"p"}>Electrical</Text>
                                <Text as={"p"}>Plumbing</Text>
                            </div>
                        )} */}
                        {(isStageView ||
                            isTaskView || isStageViewTwo) && <DropDownURL customDropdownProps={customDropdownProps} />}
                        {url && <ClearTableFilter url={url} ml={ml} />}

                    </Text>
                    {/* </div> */}
                    {/* <div className=''> */}
                    <Flex sx={{ gap: '11px' }}>
                        {isStageViewTwo && <TaskDropDownFilter />}
                        {IsBtnShow &&
                            <HeaderBtn src={Export} onClick={() => {
                                navigate('/create-project')
                            }} title={'Add Project'} />
                        }
                        {isTaskView && (<div className=' d-flex align-items-center mt-3 '>
                            <img
                                ref={iconRef}
                                src={isOverloaded ? UserRed : UserClock}
                                alt={isOverloaded ? 'user-red' : 'user-clock'}
                                style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                                onClick={() => setIsHoursPopover(!isHoursPopover)}
                            />
                            {isHoursPopover && (
                                <div ref={popoverRef} className="popover-content" style={{ position: 'absolute', top: '70px', left: '50%', zIndex: 9999, background: backgroundColor, color: titleHeader }}>
                                    <div>
                                        <h5>Overloaded Managers:</h5>
                                        {uniqueManagers.length > 0 ? (
                                            uniqueManagers?.map((manager: any, index: number) => (
                                                <Text key={index} sx={{ fontSize: '16px', fontWeight: 400 }} as="p">
                                                    {manager?.FirstName} {manager?.LastName}
                                                </Text>
                                            ))
                                        ) : (
                                            <Text>No overloaded managers</Text>
                                        )}
                                    </div>
                                    <div >
                                        <h5 className='mt-4'>Overloaded Workers:</h5>
                                        {uniqueWorkers.length > 0 ? (
                                            uniqueWorkers?.map((worker: any, index: number) => (
                                                <Text key={index} sx={{ fontSize: '16px', fontWeight: 400 }} as="p">
                                                    {worker?.FirstName} {worker?.LastName}
                                                </Text>
                                            ))
                                        ) : (
                                            <Text>No overloaded workers</Text>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>)
                        }
                        {summeryTime && <SummeryTime />}

                        <Paddingset />
                        {IsExportButtonShow && (
                            <HeaderBtn title={BtnTxt} onClick={onClick} src={src} sx={{ padding: '1px 6px' }} />
                        )}
                        {onExportClick && (
                            <HeaderBtn title="Export" onClick={onExportClick} src={Export} sx={{ padding: (isStageView || isStageViewTwo) ? 0 : '1px 6px' }} />
                        )}
                        {IsCreateButtonShow && isYourTeamView && hasRole && (
                            <HeaderBtn title={BtnTxt} onClick={onClick} src={src} sx={{ padding: '1px 6px' }} />
                        )}
                        {/* {addText && <AddStage/>} */}
                    </Flex>
                    {/* </div> */}
                </div>
            </div >

        </div >
        // </Flex >
    );
};
